/**
 * Make focusable elements backwards focusable at page load.
 */
H_Tools?.stickyheader?.makeBackwardsFocusable(
    document.querySelector('.js-site-supplementary'),
    document.querySelector('.js-site-main'),
    document.querySelector('.js-site-footer')
);
